let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bZ6NG")).then(() => parcelRequire('47YTb'));